import React,{useMemo} from "react";
import { connect } from 'react-redux';
import * as Actions from '../actions/Actions.js';
import { bindActionCreators } from 'redux';

function LikeButton(props){
  let active=useMemo(()=>{
    return(props.likes.filter((like)=>like.style_id==props.style_id).length>0)
  },[props.likes])

  let clickLike=(e)=>{
    e.stopPropagation();
    if(active){
      props.onLikeCounterChange(-1);
      props.actions.updateLikeCounter(props.shoe_id,props.style_id,-1)
      props.actions.deleteLike(props.style_id,props.shoe_id);
    }
    else{
      props.onLikeCounterChange(1);
      props.actions.updateLikeCounter(props.shoe_id,props.style_id,1)
      props.actions.addLike(props.style_id,props.shoe_id);
    }
  }

  let className= active ? "fas fa-heart" : "far fa-heart"
  return(
    <div>
      <div onClick={clickLike} style={{cursor:"pointer",zIndex:5,padding:"5px 10px",...props.containerStyle,}}>
        <i  style={{fontSize:20,...props.style,color:active? "#F43F5E" : "#999999"}} className={className}/>
      </div>
      {props.showCounter &&
        <div style={{marginTop:-10,fontSize:12,padding:"0px 2px",textAlign:"center",color:"#333333"}}>{props.likeCounter} likes</div>
      }
    </div>

  )
}


LikeButton.defaultProps={
  onLikeCounterChange:()=>{},
  showCounter:false,
}

export default connect(state => ({likes:state.persistData.likes}), (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch)
}))(LikeButton);
